import { db } from '../util/firebase'; // Tu config
import { collection, query, where, getDocs } from 'firebase/firestore/lite';

// Actions
const FETCH_REQUEST = 'app/qrStats/FETCH_REQUEST';
const FETCH_SUCCESS = 'app/qrStats/FETCH_SUCCESS';
const FETCH_ERROR = 'app/qrStats/FETCH_ERROR';

const initialState = {
  isLoading: false,
  error: null,
  stats: {
    total: 0,
    chartData: [],
    userTable: [],
    providerTable: [], // <--- NUEVO: Para la vista global de Admin,
    transactions: [], // Para el excel
  },
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_REQUEST:
      return { ...state, isLoading: true, error: null };
    case FETCH_SUCCESS:
      return { ...state, isLoading: false, stats: action.payload };
    case FETCH_ERROR:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
}

// Thunk Action
export const fetchStats = (startDate, endDate, providerId = null) => async dispatch => {
  const currentUser = providerId;

  const s = new Date(startDate);
  const startOfDay = new Date(
    s.getUTCFullYear(),
    s.getUTCMonth(),
    s.getUTCDate(),
    0,
    0,
    0,
    0 // 00:00:00 Local
  );

  const e = new Date(endDate);
  const endOfDay = new Date(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    23,
    59,
    59,
    999 // 23:59:59 Local
  );

  dispatch({ type: FETCH_REQUEST });

  try {
    const constraints = [where('timestamp', '>=', startOfDay), where('timestamp', '<=', endOfDay)];

    if (providerId) {
      constraints.push(where('providerId', '==', providerId));
    }

    const q = query(collection(db, 'qr_transactions'), ...constraints);
    const snapshot = await getDocs(q);

    const rawDocs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Processing data
    const statsByDate = {};
    const statsByUser = {};
    const statsByProvider = {}; // <--- NUEVO
    let total = 0;

    rawDocs.forEach(doc => {
      total++;

      let dateKey = '';

      try {
        const date = doc.timestamp.toDate();
        date.setHours(0, 0, 0, 0);
        dateKey = date.toISOString().split('T')[0];
      }catch(e) {
        const date = new Date(doc.timestamp)
        date.setHours(0, 0, 0, 0);
        dateKey = date.toISOString().split('T')[0];
      }

      statsByDate[dateKey] = (statsByDate[dateKey] || 0) + 1;


      // 2. Tabla de Usuarios (Consumidores)
      const userId = doc.userId || 'anonymous';
      const userDisplayName = doc.userDisplayName || 'Usuario Anónimo';
      const scanDate = doc.timestamp?.toDate ? doc.timestamp.toDate() : new Date(doc.timestamp);

      if (!statsByUser[userId]) {
        statsByUser[userId] = {
          userId,
          displayName: userDisplayName,
          scanCount: 0,
          lastScan: scanDate,
          history: [],
        };
      }
      statsByUser[userId].scanCount++;
      if (scanDate > statsByUser[userId].lastScan) {
        statsByUser[userId].lastScan = scanDate;
      }
      statsByUser[userId].history.push({ timestamp: scanDate });

      // 3. Tabla de Proveedores (Para Admin Global) ---> NUEVO
      // Nota: Si providerId es null (admin view), esto llenará la lista de proveedores.
      const pId = doc.providerId;
      const pName = doc.providerName || 'Proveedor Desconocido'; // Asegúrate de guardar esto en backend o vendrá por default

      if (!statsByProvider[pId]) {
        statsByProvider[pId] = {
          id: pId,
          displayName: pName,
          scanCount: 0,
        };
      }
      statsByProvider[pId].scanCount++;
    });

    const chartData = Object.keys(statsByDate)
      .sort()
      .map(date => ({
        name: date,
        scans: statsByDate[date],
      }));

    const userTable = Object.values(statsByUser).sort((a, b) => b.scanCount - a.scanCount);

    // Ordenamos proveedores por actividad
    const providerTable = Object.values(statsByProvider).sort((a, b) => b.scanCount - a.scanCount);

    const processedData = {
      total,
      chartData,
      userTable,
      providerTable, // <--- Agregado al payload
      transactions: rawDocs,
    };

    dispatch({ type: FETCH_SUCCESS, payload: processedData });
  } catch (e) {
    console.error('error al obtener', e);
    dispatch({ type: FETCH_ERROR, payload: e.message });
  }
};
